var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "cookies-panel" }, [
    _c("div", { staticClass: "cookies-panel__settings" }, [
      _c("div", { staticClass: "cookies-panel__settings--wrapper" }, [
        _c("div", { staticClass: "settings__title" }, [
          _c("h6", [
            _vm._v(_vm._s(_vm.text.cookies.cookies_policy.title) + " ")
          ]),
          _vm._v(" "),
          _vm._m(0)
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "cookies-panel__settings--wrapper" }, [
        _c("div", { staticClass: "settings__title" }, [
          _c("h6", [_vm._v(_vm._s(_vm.text.cookies.performance.title))]),
          _vm._v(" "),
          _c("label", { staticClass: "cookie-switch" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.checkedCookies,
                  expression: "checkedCookies"
                }
              ],
              attrs: { type: "checkbox", value: "performance" },
              domProps: {
                checked: Array.isArray(_vm.checkedCookies)
                  ? _vm._i(_vm.checkedCookies, "performance") > -1
                  : _vm.checkedCookies
              },
              on: {
                click: function($event) {
                  $event.stopPropagation()
                },
                change: function($event) {
                  var $$a = _vm.checkedCookies,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = "performance",
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.checkedCookies = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.checkedCookies = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.checkedCookies = $$c
                  }
                }
              }
            }),
            _vm._v(" "),
            _c("span", { staticClass: "cookie-switch--slider" })
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "cookies-panel__settings--wrapper" }, [
        _c("div", { staticClass: "settings__title" }, [
          _c("h6", [_vm._v(_vm._s(_vm.text.cookies.marketing.title))]),
          _vm._v(" "),
          _c("label", { staticClass: "cookie-switch" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.checkedCookies,
                  expression: "checkedCookies"
                }
              ],
              attrs: { type: "checkbox", value: "marketing" },
              domProps: {
                checked: Array.isArray(_vm.checkedCookies)
                  ? _vm._i(_vm.checkedCookies, "marketing") > -1
                  : _vm.checkedCookies
              },
              on: {
                click: function($event) {
                  $event.stopPropagation()
                },
                change: function($event) {
                  var $$a = _vm.checkedCookies,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = "marketing",
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.checkedCookies = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.checkedCookies = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.checkedCookies = $$c
                  }
                }
              }
            }),
            _vm._v(" "),
            _c("span", { staticClass: "cookie-switch--slider" })
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn",
          attrs: { type: "submit" },
          on: { click: _vm.submit }
        },
        [_vm._v(_vm._s(_vm.text.button.confirm))]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "cookie-switch" }, [
      _c("input", { attrs: { type: "checkbox", disabled: "", checked: "" } }),
      _vm._v(" "),
      _c("span", { staticClass: "cookie-switch--slider cookie-switch--locked" })
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4d1d5c7a", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d1d5c7a","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./frontend/components/cookies-panel/cookies-panel.vue
// module id = 124
// module chunks = 0